import { mapGetters } from "vuex";

import { ENABLED_IN } from "../constants/contributions-configuration";
import { contributionsConfigurationIsPaused } from "../store/getters";

export default {
  computed: {
    ...mapGetters({
      contributionsConfigurationEnabledIn: "contributionsConfigurationEnabledIn",
      contributionsConfigurationActivationThresholdAmount: "contributionsConfigurationActivationThresholdAmount",
      contributionsConfigurationIsPaused: "contributionsConfigurationIsPaused",
    }),
  },
  methods: {
    contributionsEnabledForProductPrice(price, list = null) {
      if (list && !list.stripeAccountId) {
          return false;
      }

      if (this.contributionsConfigurationEnabledIn !== ENABLED_IN.all) {
          return false;
      }

      if (price < this.contributionsConfigurationActivationThresholdAmount) {
          return false;
      }

      if (this.contributionsConfigurationIsPaused) return false;

      return true;
    }
  },
}
